import { Action } from '@ngrx/store';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel } from 'src/app/shared/interfaces/CriteriaModel';

export enum ActionTypes {
	CreateAppointment = 'CreateAppointment',
	CreateAppointmentSuccess = 'CreateAppointmentSuccess',
	CreateAppointmentError = 'CreateAppointmentError',

	GetAppointments = 'GetAppointments',
	GetAppointmentsSuccess = 'GetAppointmentsSuccess',
	GetAppointmentsError = 'GetAppointmentsError',

	RescheduleAppointment = 'RescheduleAppointment',
	RescheduleAppointmentSuccess = 'RescheduleAppointmentSuccess',
	RescheduleAppointmentError = 'RescheduleAppointmentError',

	CancelAppointment = 'CancelAppointment',
	CancelAppointmentSuccess = 'CancelAppointmentSuccess',
	CancelAppointmentError = 'CancelAppointmentError',
}

export class CreateAppointment implements Action {
	readonly type = ActionTypes.CreateAppointment;

	constructor(public payload: any) {
	}
}

export class CreateAppointmentSuccess implements Action {
	readonly type = ActionTypes.CreateAppointmentSuccess;

	constructor(public payload: any) {
	}
}

export class CreateAppointmentError implements Action {
	readonly type = ActionTypes.CreateAppointmentError;

	constructor(public payload: AusmitError) {
	}
}

export class GetAppointments implements Action {
	readonly type = ActionTypes.GetAppointments;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetAppointmentsSuccess implements Action {
	readonly type = ActionTypes.GetAppointmentsSuccess;

	constructor(public payload: any) {
	}
}

export class GetAppointmentsError implements Action {
	readonly type = ActionTypes.GetAppointmentsError;

	constructor(public payload: AusmitError) {
	}
}

export class RescheduleAppointment implements Action {
	readonly type = ActionTypes.RescheduleAppointment;

	constructor(public payload: { appointmentID: string, params: any }) {
	}
}

export class RescheduleAppointmentSuccess implements Action {
	readonly type = ActionTypes.RescheduleAppointmentSuccess;

	constructor(public payload: any) {
	}
}

export class RescheduleAppointmentError implements Action {
	readonly type = ActionTypes.RescheduleAppointmentError;

	constructor(public payload: AusmitError) {
	}
}

export class CancelAppointment implements Action {
	readonly type = ActionTypes.CancelAppointment;

	constructor(public payload: { appointmentID: string, params: any }) {
	}
}

export class CancelAppointmentSuccess implements Action {
	readonly type = ActionTypes.CancelAppointmentSuccess;

	constructor(public payload: any) {
	}
}

export class CancelAppointmentError implements Action {
	readonly type = ActionTypes.CancelAppointmentError;

	constructor(public payload: AusmitError) {
	}
}



export type Actions =
	| CreateAppointment
	| CreateAppointmentSuccess
	| CreateAppointmentError
	| GetAppointments
	| GetAppointmentsSuccess
	| GetAppointmentsError
	| RescheduleAppointment
	| RescheduleAppointmentSuccess
	| RescheduleAppointmentError
	| CancelAppointment
	| CancelAppointmentSuccess
	| CancelAppointmentError;

